export default "__VITE_ASSET__nRKNlX7L__"